



























































































































































































import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";
import { Workspace, IWorkspaceData } from "@/entities";
import OwnershipChange from "@/components/App/Modules/GMS/Grants/GrantSummary/OwnershipChange.vue";
import { Locales } from "@/i18n/locales";

const namespace: string = "application";

@Component({
  components: {
    OwnershipChange,
  }
})
export default class AppSummaryComponent extends Vue {
  @Action("updatePPO", { namespace: "application" }) updatePPO: any;
  @Action("changeOwnership", { namespace: "application" }) changeOwnership: any;

  @Prop() appInfo: any;
  @Prop() internalReview: any;
  @State(namespace) application!: Workspace;
  actions = _app.actions;
  subjects = _app.subjects;
  dialog=false;
  readonlyPPO = 0;
  editedPPO = 0;
  items=[]
  showEdit=false;
  submitStatus: any = _app.updatePPO;
  ownerId = 0;
  leadUsers = [];
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;
  mounted()
  {
     this.$services.application.ActiveUsersByUserType(this.application.application.ApplicationId)
        .then((resp: any) => {
            if (resp.Result == 'OK') {
                this.items = resp.Record;
            }
        });
    this.readonlyPPO = this.application.application.PrimaryProgramOfficerId
    this.editedPPO=this.application.application.PrimaryProgramOfficerId

    this.$services.application.ActiveLeadUsers(this.application.application.ApplicationId)
        .then((resp: any) => {
            if (resp.Result == 'OK') {
                this.leadUsers = resp.Record;
            }
        });

    this.ownerId = this.appInfo.CreatedById;  
  }

  updateOwner(data) {
    this.changeOwnership({
            id: data.id,
            userId: data.userId,
        }).then((resp) => {
            this.appInfo.CreatedById = data.userId;
        });
  }

  /** open a read only view of application in new tab */
  openApplication(applicationId, context) {
    switch (context) {
      case "readonly":
        let routeData = this.$router.resolve({
          name: "viewApplication",
          params: { appId: applicationId, section: 'technicalApplication' },
        });
        window.open(routeData.href, "_blank");
        break;
      case "edit":        
        this.$router.push({
          name: "applSummary",
          params: { applicationId: applicationId }
        });
        break;
    }
  }

  cancelPPO() {
        this.dialog = false
        this.editedPPO = this.readonlyPPO
    }

    savePPO() {
        this.updatePPO({
            id: this.application.application.ApplicationId,
            ppoid: this.editedPPO
        })
        .then((resp) => {
            this.readonlyPPO = this.application.application.PrimaryProgramOfficerId
            this.dialog = false
        })
    }

  get enableButton() {
    //@ts-ignore
    if (this.$can(this.actions.update, this.subjects.ppo) && (this.submitStatus.submit.includes(this.application.application.WorkflowStatusCode))) {
      return true;
    }
    else {
      return false;
    }
  }

    /** permissions for changing ownership */
  get enableButtonForSysAdmin() {
    //@ts-ignore
    if (this.$can(this.actions.update, this.subjects.ownershipChange)) {
      // show button for system admins
      return true;
    }
  }

  formatCurrency(val) {
    return utils.formatCurrency(val, this.appInfo.BudgetCurrency, this.defaultLocale);
  }
}
